module.exports = __webpack_public_path__ + "static/img/kv_deco_02.d59e255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/kv_deco_02.png
// module id = hQa/
// module chunks = 0